import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

// import React, { use } from "react";
// import missionIcon from "../assets/images/mission.png";
// import visionIcon from "../assets/images/vision.png";
// import valueIcon from "../assets/images/value.png";

import { useRef, useEffect, useState, use } from "react";
// management images (replace with actual paths)
// import johnImg from "../assets/images/john.jpg";
// import graceImg from "../assets/images/grace.jpg";
// import peterImg from "../assets/images/peter.jpg";
// import maryImg from "../assets/images/mary.jpg";
// import davidImg from "../assets/images/david.jpg";
// import anitaImg from "../assets/images/anita.jpg";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
// import Newsletter from "../Components/Newsletter";
// import FAQ from "../Components/FAQ";
import { Getdata } from "../helpers/api.service";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
// import Card  from "../Components/Card";

const About = (props) => {
  const [boardMember, setBoardMember] = useState([]);
  const [schoolManagementData, setSchoolManagementData] = useState([]);
  const [teachersData, setTeachersData] = useState([]);
  const [aboutUs, setAboutUs] = useState({});
  const [profile, setProfie] = useState({});
  const [countryCode, setCountryCode] = useState("");

  const [boardManagementLabel, setBoardManagementLabel] = useState("");

  useEffect(() => {
    if (countryCode?.toUpperCase() === "UG") {
      setBoardManagementLabel(countryCode?.toUpperCase() === "UG"
      ? "School Management Committee"
      : "Board of Management");
    }
  }, [countryCode]);


  const fetchschoolManagementData = () => {
    Getdata(
      process.env.REACT_APP_URL +
        `/front/management/fetch/${process.env.REACT_APP_SUBDOMAIN}`,
    )
      .then((res) => {
        setSchoolManagementData(res.data.managers);
      })
      .catch((err) => {
        console.error("Error fetching FAQ:", err);
      });
  };
  const fetchteacherData = () => {
    Getdata(
      process.env.REACT_APP_URL +
        `/front/teacher/fetch/${process.env.REACT_APP_SUBDOMAIN}`,
    )
      .then((res) => {
        setTeachersData(res.data.teacher);
      })
      .catch((err) => {
        console.error("Error fetching FAQ:", err);
      });
  };
  const fetchBoardMember = () => {
    Getdata(
      process.env.REACT_APP_URL +
        `/front/board-management/fetch/${process.env.REACT_APP_SUBDOMAIN}`,
    )
      .then((res) => {
        setBoardMember(res.data.boards);
      })
      .catch((err) => {
        console.error("Error fetching FAQ:", err);
      });
  };
  const fetchAboutUs = () => {
    Getdata(
      process.env.REACT_APP_URL +
        `/front/about/${process.env.REACT_APP_SUBDOMAIN}`,
    )
      .then((res) => {
        setAboutUs(res.data);
      })
      .catch((err) => {
        console.error("Error fetching FAQ:", err);
      });
  };
  const fetchProfile = () => {
    // setLoading(true);
    Getdata(
      process.env.REACT_APP_URL +
        `/front/profile/${process.env.REACT_APP_SUBDOMAIN}`,
    )
      .then((res) => {
        if (res?.data) {
          setProfie(res.data);
          if (res.data.country_code) {
            setCountryCode(res.data.country_code);
          }
        }
      })
      .catch((err) => {
        console.error("Error fetching FAQ:", err);
      });
  };

  useEffect(() => {
    fetchBoardMember();
    fetchschoolManagementData();
    fetchteacherData();
    fetchAboutUs();
    fetchProfile();
  }, []);

  const items = [
    {
      title: "Mission",
      icon: profile?.history_image,
      text: profile?.history,
    },
    {
      title: "Vision",
      icon: profile?.why_us_image,
      text: profile?.why_us,
    },
    {
      title: "Value",
      icon: profile?.value_image,
      text: profile?.value,
    },
  ];

  const Card = ({ member }) => (
    <div className="bg-white shadow-md h-[30vh] w-[260px] rounded-xl p-4 text-center mx-3 hover:shadow-lg transition duration-300 flex flex-col group">
      {/* Top: Profile Image */}
      <div className="flex-shrink-0">
        <img
          src={member.profile_img}
          alt={member.name}
          className="w-20 h-20 rounded-full mx-auto mb-2 object-cover"
        />
      </div>

      {/* Middle: Name + Designation */}
      <div className="flex-shrink-0">
        <h4 className="font-bold text-lg truncate">{member.name}</h4>
        <p className="text-sm mb-2 text-gray-500 truncate">
          {member.designation}
        </p>
      </div>

      {/* Bottom: Description (fills remaining space) */}
      <div className="flex-1 hover:overflow-y-auto overflow-hidden ">
        <p className="text-gray-600 text-sm text-left">{member.description}</p>
      </div>
    </div>
  );

  // const AutoBulletSwiper = ({ data, ariaLabel }) => {
  //   const swiperRef = useRef(null);

  //   useEffect(() => {
  //     if (!swiperRef.current) return;
  //     const swiper = swiperRef.current.swiper;

  //     let index = 0;
  //     const interval = setInterval(() => {
  //       if (!swiper.pagination?.bullets) return;
  //       index = (index + 1) % swiper.pagination.bullets.length;
  //       swiper.slideToLoop(index);
  //     }, 5000);

  //     return () => clearInterval(interval);
  //   }, []);

  //   return (
  //     <Swiper
  //       modules={[Navigation, Pagination]}
  //       spaceBetween={20}
  //       slidesPerView={1}
  //       navigation
  //       pagination={{ clickable: true }}
  //       autoplay={false}
  //       loop={true}
  //       breakpoints={{
  //         640: { slidesPerView: 1 },
  //         768: { slidesPerView: 2 },
  //         1024: { slidesPerView: 3 },
  //       }}
  //       className="mySwiper"
  //       aria-label={ariaLabel}
  //       ref={swiperRef}
  //     >
  //       {data.map((item, index) => (
  //         <SwiperSlide key={index}>
  //           <Card member={item} />
  //         </SwiperSlide>
  //       ))}
  //     </Swiper>
  //   );
  // };

  const ManualSwiper = ({ data, ariaLabel }) => {
    const swiperRef = useRef(null);

    // Import icons from react-icons

    return (
      <div className="relative">
        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={20}
          slidesPerView={1}
          navigation={{
            nextEl: `.swiper-button-next-${ariaLabel}`,
            prevEl: `.swiper-button-prev-${ariaLabel}`,
          }}
          pagination={{ clickable: true }}
          loop={true}
          breakpoints={{
            640: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
          }}
          className="mySwiper"
          aria-label={ariaLabel}
          ref={swiperRef}
        >
          {data.map((item, index) => (
            <SwiperSlide key={index}>
              <Card member={item} />
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Custom navigation buttons with icons */}
        <button
          className={`swiper-button-prev-${ariaLabel} absolute top-[40%] transform -translate-y-1/2 z-10 text-black text-2xl rounded-full hover:bg-gray-200 transition duration-300
      left-4 sm:left-4 md:left-6 lg:-left-3 xl:-left-5 flex items-center justify-center w-10 h-10`}
        >
          <FaChevronLeft />
        </button>
        <button
          className={`swiper-button-next-${ariaLabel} absolute top-[40%] transform -translate-y-1/2 z-10 text-black text-2xl rounded-full hover:bg-gray-200 transition duration-300
      right-4 sm:right-4 md:right-6 lg:-right-3 xl:-right-5 flex items-center justify-center w-10 h-10`}
        >
          <FaChevronRight />
        </button>
      </div>
    );
  };

  return (
    <div className="py-16 bg-gray-50">
      {/* About Section */}
      <div>
        <h2 className="text-f100 text-primary_main text-center font-bold mb-8 md:mb-12 ">
          About Us
        </h2>
        <div
          className="text-f15 text-center px-6 md:px-12 lg:px-20 xl:px-40 mx-auto mb-8 md:mb-12 text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl"
          dangerouslySetInnerHTML={{ __html: aboutUs?.text || "" }}
        />
      </div>

      {/* Mission, Vision, Values */}
      <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-8 px-6 md:px-12 lg:px-20 mb-20">
        {items.map((item, index) => (
          <div
            key={index}
            className="bg-[#F9F5FF] shadow-lg rounded-2xl p-8 text-center hover:shadow-xl transition duration-300 whitespace-normal break-words"
          >
            <img
              src={item.icon}
              alt={item.title}
              className="w-24 h-24 mx-auto mb-6"
            />
            <h3 className="text-xl font-bold mb-4">{item.title}</h3>
            <p className="text-gray-600 text-sm md:text-base leading-relaxed">
              {item.text}
            </p>
          </div>
        ))}
      </div>

      <div className="bg-[#FFF6F4] py-8">
        {/* Board of Management */}
        <div className="mb-16 flex flex-col lg:flex-row items-center text-left justify-center lg:justify-evenly">
          <h3
            className="text-f40 font-bold mb-6 px-6 w-full lg:w-1/5 text-center lg:text-left"
            aria-label={boardManagementLabel}
          >
            {countryCode?.toUpperCase() === "UG" ? (
              <>
                School Management{" "}
                <span className="text-primary_main">Committee</span>
              </>
            ) : (
              <>
                Board of <span className="text-primary_main">Management</span>
              </>
            )}
          </h3>
          <div className="w-full lg:w-3/5">
            <ManualSwiper data={boardMember} ariaLabel="BoardManagement" />
          </div>
        </div>

        {/* School Management */}
        <div className="mb-16 flex flex-col lg:flex-row items-center text-left justify-center lg:justify-evenly">
          <h3
            className="text-f40 font-bold mb-6 px-6 w-full lg:w-1/5 text-center lg:text-left"
            aria-label="School Management"
          >
            School <span className="text-primary_main">Management</span>
          </h3>
          <div className="w-full lg:w-3/5">
            <ManualSwiper
              data={schoolManagementData}
              ariaLabel="SchoolManagement"
            />
          </div>
        </div>

        {/* Teachers */}
        <div className="flex flex-col lg:flex-row items-center text-left justify-center lg:justify-evenly">
          <h3
            className="text-f40 font-bold mb-6 px-6 w-full lg:w-1/5 text-center lg:text-left"
            aria-label="Teachers"
          >
            <span className="text-primary_main">Teachers</span>
          </h3>
          <div className="w-full lg:w-3/5">
            <ManualSwiper data={teachersData} ariaLabel="Teachers" />
          </div>
        </div>
      </div>
      {/* <Newsletter />
      <FAQ /> */}
    </div>
  );
};

export default About;
